import { connect } from 'react-redux';
import { changeCommissionStatus } from '../../../redux/commissions/actionCreators';
var mapDispatchToProps = {
    onClick: changeCommissionStatus,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=CommissionStatusButton.container.js.map